/**
 * CARTO raster basemap tile URLs.
 *
 * CARTO watermarks raster tiles requested without an API key, so the key
 * (VITE_CARTO_KEY) is appended when present.
 */

const CARTO_KEY = import.meta.env.VITE_CARTO_KEY as string | undefined;

export function cartoTileUrl(style: 'rastertiles/voyager' | 'dark_all'): string {
  const url = `https://{s}.basemaps.cartocdn.com/${style}/{z}/{x}/{y}{r}.png`;
  return CARTO_KEY ? `${url}?key=${CARTO_KEY}` : url;
}
